// export const API_FETCH = "https://m6hsr3z5-7000.uks1.devtunnels.ms";
export const API_FETCH = "https://portal.sabrecwa.com/backend";

export const Server_API = "https://admin.sabrecwa.com/sitebackend/onboard";

// export const server_API = "https://m6hsr3z5-4000.uks1.devtunnels.ms";
